import * as palette from "../../palette";

export default function getReclameAquiClassificationTextColor(finalScore: number): string {
  // Ótimo
  if (finalScore >= 8 && finalScore <= 10) {
    return palette.goblin;
  }

  // Bom
  if (finalScore >= 7 && finalScore <= 7.9) {
    return palette.cobalt;
  }

  // Regular
  if (finalScore >= 6 && finalScore <= 6.9) {
    return palette.copper;
  }

  // Ruim
  if (finalScore >= 5 && finalScore <= 5.9) {
    return palette.mojo;
  }

  // Não Recomendada
  return palette.linkVisited;
}
